module.exports = __webpack_public_path__ + "static/media/header-divider.b3a8646c.svg";